import { useLocalSearchParams } from 'expo-router';

import { PublicTenantProfileScreen } from '@/components/profiles/public-tenant-profile-screen';

export default function PublicTenantProfileRoute() {
  const { tenant: tenantSlug } = useLocalSearchParams<{ tenant: string }>();

  return (
    <PublicTenantProfileScreen
      backFallbackHref="/"
      eventHref={(tenant, event) => ({
        pathname: '/[tenant]/events/[id]',
        params: { tenant: tenant.slug, id: event.id },
      })}
      eventsHref={(tenant) => ({
        pathname: '/[tenant]/events',
        params: { tenant: tenant.slug },
      })}
      tenantSlug={tenantSlug}
    />
  );
}
